import { Link } from "react-router-dom";

interface HeaderProps {
  credits?: number;
}

export function Header({ credits }: HeaderProps) {
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur-sm">
      <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4">
        <Link to="/dashboard" className="text-lg font-bold text-slate-900">
          HelloConvo
        </Link>
        <div className="flex items-center gap-3">
          {credits !== undefined && (
            <Link
              to="/usage"
              className="font-data text-sm text-slate-600 hover:text-slate-900"
            >
              {credits} credits
            </Link>
          )}
          <Link
            to="/settings"
            className="rounded-full bg-slate-100 p-2 text-slate-500 hover:bg-slate-200"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </Link>
        </div>
      </div>
    </header>
  );
}
